<template>
  <div class="battle-sp-tip">
    <img ref="tippyTarget" class="tippy-target" src="@/assets/zs_imgs/battle/question.png" />
    <div ref="tippyContent" class="tippy-content">
      <div class="header">
        <div class="title">
          <span>{{ $t("tj.zs.bhhxh") }}：{{ usedSp }}SP</span>
        </div>
        <div class="close" @click="handleCloseTippy"></div>
      </div>
      <div class="body">
        <div class="spdesc">{{ $t("tj.zs.chjqszd") }}：{{ baseSp }}SP</div>
        <ul class="content-list">
          <li class="content-item">
            <div class="sort">1</div>
            <div class="content sp-list">
              <div class="sp-item">
                <img src="@/assets/zs_imgs/battle/round_star.png" />
                <span>={{ $t("tj.zs.zjsysp") }}</span>
              </div>
              <div class="sp-item">
                <img src="@/assets/zs_imgs/battle/used_star.png" />
                <span>={{ $t("tj.zs.xhsp") }}</span>
              </div>
              <div class="sp-item">
                <img src="@/assets/zs_imgs/battle/default_star.png" />
                <span>={{ $t("tj.zs.spbjbj") }}</span>
              </div>
              <div class="sp-item">
                <img src="@/assets/zs_imgs/battle/error_star.png" />
                <span>={{ $t("tj.zs.spsywf") }}</span>
              </div>
            </div>
          </li>
          <li v-for="(value, index) in source" :key="index" class="content-item">
            <div class="sort">{{ index + 2 }}</div>
            <div class="content">{{ value }}</div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import tippy from "@/plugins/tippy";

export default {
  name: "BattleSpTip",
  props: { usedSp: { type: Number, default: 0 }, baseSp: { type: Number, default: 0 } },
  data() {
    return {
      source: [
        this.$t("tj.zs.spszzdtzsyjnssxdds"),
        this.$t("tj.zs.mhhjssfhfsojnsxyhhzsphhfbfsp"),
        this.$t("tj.zs.mhhjsgjhjtsxyhhzsphhf1sp")
      ]
    };
  },
  mounted() {
    this.initTippy();
  },
  methods: {
    initTippy() {
      const target = this.$refs.tippyTarget;
      const content = this.$refs.tippyContent;
      if (!target || !content) {
        setTimeout(this.initTippy, 30);
        return;
      }
      this.tippy = tippy(target, {
        content,
        arrow: false,
        interactive: true,
        maxWidth: "none",
        trigger: "mouseenter click",
        placement: "bottom-start",
        theme: "tippy-clear-style-theme",
        onCreate() {
          content.style.position = "static";
          content.style.visibility = "visible";
        }
      });
    },
    handleCloseTippy() {
      this.tippy.hide();
    }
  }
};
</script>
<style lang="less" scoped>
ul {
  padding-inline-start: 0;
}
.battle-sp-tip {
  .tippy-target {
    display: block;
    width: 18px;
    height: 17px;
    cursor: pointer;
  }
  .tippy-content {
    visibility: hidden;
    position: fixed;
    width: 460px;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.2);
    background: linear-gradient(180deg, #ffffff 0%, #ffffff 100%);
    .header {
      background-color: rgba(0, 0, 0, 0.05);
      height: 48px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 20px;
      font-size: 14px;
      font-weight: bold;
      color: #333;
      .title {
        display: flex;
        white-space: nowrap;
        column-gap: 20px;
      }
      .close {
        width: 16px;
        height: 16px;
        cursor: pointer;
        background: url("~@/assets/zs_imgs/battle/close.png") center / cover no-repeat;
      }
    }
    .body {
      padding: 0 20px 8px;
      .spdesc {
        color: #333;
        font-size: 13px;
        padding: 12px 0 4px;
      }
      .content-list {
        .content-item {
          display: flex;
          align-items: center;
          column-gap: 8px;
          &:last-child .content {
            border-bottom: none;
          }
          .sort {
            width: 12px;
            height: 12px;
            line-height: 12px;
            text-align: center;
            font-size: 11px;
            color: #fff;
            background-color: #666666;
          }
          .content {
            flex-grow: 1;
            color: #333;
            line-height: 42px;
            font-size: 13px;
            box-sizing: content-box;
            border-bottom: 1px solid rgba(0, 0, 0, 0.08);
          }
          .sp-list {
            display: flex;
            column-gap: 20px;
            .sp-item {
              display: flex;
              align-items: center;
              img {
                width: 10px;
                height: 10px;
                transform: translateY(1px);
              }
            }
          }
        }
      }
    }
  }
}
</style>
